"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _numeral = _interopRequireDefault(require("@package/numeral"));

var _dicts = require("@package/dicts");

var _react = _interopRequireWildcard(require("react"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var SummaryTable = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(SummaryTable, _PureComponent);

  var _super = (0, _createSuper2["default"])(SummaryTable);

  function SummaryTable() {
    var _this;

    (0, _classCallCheck2["default"])(this, SummaryTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this._getPayoutMethod = function (name) {
      switch (name) {
        case 'WMR':
          return 'WMP';

        case 'WMZ':
          return 'WMZ';

        case 'Qiwi':
          return 'Qiwi';

        case 'YandexMoney':
          return 'Яндекс.Деньги';

        case 'BankCard':
          return 'Банковские карты';

        case 'Mobile':
          return 'Мобильные операторы';

        case 'Transfer':
          return 'Переводы';

        default:
          return '';
      }
    };

    _this._calculateAccount = function (account) {
      return account.reduce(function (result, current) {
        return [result[0] + current['amount'], result[1] + current['length'], result[2] + current['amountWithCommission'], current['currency']];
      }, [0, 0, 0, '']);
    };

    _this._getAccounts = function (accounts) {
      var result = [];

      for (var currency in accounts) {
        if (accounts.hasOwnProperty(currency)) {
          var account = accounts[currency];
          var accountMethods = [];

          for (var method in account) {
            if (account.hasOwnProperty(method)) {
              var item = account[method];
              accountMethods.push((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, item), {}, {
                method: method,
                currency: currency
              }));
            }
          }

          result.push(accountMethods);
        }
      }

      return result;
    };

    return _this;
  }

  (0, _createClass2["default"])(SummaryTable, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var items = this.props.items;

      var accounts = this._getAccounts(items);

      return accounts.map(function (account, index) {
        var accountFullAmount = _this2._calculateAccount(account);

        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _defaultModule["default"]['account'],
          key: index
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _defaultModule["default"]['table']
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _defaultModule["default"]['table__head']
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _defaultModule["default"]['table__head-td']
        }, "\u0421\u043F\u043E\u0441\u043E\u0431"), /*#__PURE__*/_react["default"].createElement("div", {
          className: _defaultModule["default"]['table__head-td']
        }, "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E"), !!accountFullAmount[2] && /*#__PURE__*/_react["default"].createElement("div", {
          className: _defaultModule["default"]['table__head-td']
        }, "\u0421\u043F\u0438\u0441\u0430\u043D\u0438\u0435"), /*#__PURE__*/_react["default"].createElement("div", {
          className: _defaultModule["default"]['table__head-td']
        }, "\u0417\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u0435")), account.map(function (item, index) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: _defaultModule["default"]['table__row'],
            key: index
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: _defaultModule["default"]['table__row-td']
          }, _this2._getPayoutMethod(item['method'])), /*#__PURE__*/_react["default"].createElement("div", {
            className: _defaultModule["default"]['table__row-td']
          }, item['length']), !!item['amountWithCommission'] && /*#__PURE__*/_react["default"].createElement("div", {
            className: _defaultModule["default"]['table__row-td']
          }, (0, _numeral["default"])(item['amountWithCommission']).format(), " ", _dicts.CURRENCY_SYMBOLS[item['currency']]), /*#__PURE__*/_react["default"].createElement("div", {
            className: _defaultModule["default"]['table__row-td']
          }, (0, _numeral["default"])(item['amount']).format(), " ", _dicts.CURRENCY_SYMBOLS[item['currency']]));
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: _defaultModule["default"]['table__footer']
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _defaultModule["default"]['table__footer-td']
        }, "\u0418\u0442\u043E\u0433\u043E"), /*#__PURE__*/_react["default"].createElement("div", {
          className: _defaultModule["default"]['table__footer-td']
        }, accountFullAmount[1]), !!accountFullAmount[2] && /*#__PURE__*/_react["default"].createElement("div", {
          className: _defaultModule["default"]['table__footer-td']
        }, (0, _numeral["default"])(accountFullAmount[2]).format(), " ", _dicts.CURRENCY_SYMBOLS[accountFullAmount[3]]), /*#__PURE__*/_react["default"].createElement("div", {
          className: _defaultModule["default"]['table__footer-td']
        }, (0, _numeral["default"])(accountFullAmount[0]).format(), " ", _dicts.CURRENCY_SYMBOLS[accountFullAmount[3]]))));
      });
    }
  }]);
  return SummaryTable;
}(_react.PureComponent);

var _default = SummaryTable;
exports["default"] = _default;